const documentValidationConfig = {
    'company_gstin': {
        'regex': /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/,
        'max_length': 15,
        'error_message': 'Please enter Vaild Company GST Number'
    },
    'company_pan_card': {
        'regex': /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        'max_length': 10,
        'error_message': 'Please enter Vaild Company Pan Number'
    },
    'udyog_aadhar_number': {
        'regex': /^[A-Z0-9]{12}$/,
        'max_length': 12,
        'error_message': 'Please enter Valid Udyog Aadhaar Number'
    },
    'shops_and_establishment_act': {
        'regex': /r"^[A-Z0-9\-/]{1,25}$"/,
        'max_length': 25,
        'error_message': 'Please enter Valid Registration Number'
    },
    'food_license': {
        'regex': /^[12]{1}[0-9]{13}$/,
        'max_length': 14,
        'error_message': 'Please enter Vaild License Number'
    },
    'corporate_identity_number': {
        'regex': /^[UL]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
        'max_length': 21,
        'error_message': 'Please enter Vaild Corporate Identity Number'
    },
    'other':{
        'regex': /^[A-Z0-9\-/]{1,25}$/,
        'max_length': 25,
        'error_message': 'Please enter Vaild Document Number'
    }
}

export default documentValidationConfig